import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import ScopedCssBaseline from "@mui/material/ScopedCssBaseline";
import { theme } from "./theme";

export function ThemeProvider({ children }) {
  return (
    <MuiThemeProvider theme={theme}>
      <ScopedCssBaseline enableColorScheme={false}>
        {children}
      </ScopedCssBaseline>
    </MuiThemeProvider>
  );
}

export default ThemeProvider;
